import React from 'react';
import { initializeGA } from '../config/ga-config';
import { ModalContextProvider, ModalContext } from '../context/modal-context';
import { UserContextProvider } from '../context/user-context';
import { useErrorHandler } from '../hooks/useErrorHandler';
import { normalizePathname, numericPageUid5 } from '../utils/analytics/uid5';

const ModalRenderer = () => {
	const { modalActive } = React.useContext(ModalContext)
	return modalActive
}

const RootWrapper = ({ children }) => {
	useErrorHandler()
	return (
		<>
			{children}
			<ModalRenderer />
		</>
	)
}

export const wrapRootElement = ({ element }) => (
  <UserContextProvider>
    <ModalContextProvider>
      <RootWrapper>{element}</RootWrapper>
    </ModalContextProvider>
  </UserContextProvider>
);

export const createOnClientEntry = () => () => {
  const GA_MEASUREMENT_ID = process.env.GATSBY_GTM_ID;
  initializeGA(GA_MEASUREMENT_ID);
};

export const createOnPreRouteUpdate = (getPageType, microPrefix = 'home') => {
  let lastSlug = null;
  return ({ location }) => {
    const nextSlug = normalizePathname(location?.pathname || '/');
    if (window.__FIRST_PAIR_PUSHED_SLUG__ === nextSlug) { window.__FIRST_PAIR_PUSHED_SLUG__ = null; lastSlug = nextSlug; return; }
    if (nextSlug === lastSlug) return;
    lastSlug = nextSlug;

    const page_uid  = numericPageUid5(microPrefix, nextSlug);
    const page_type = getPageType(nextSlug);
    pushToDataLayer({ page_uid, page_type });
  };
};

function pushToDataLayer(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}
